import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Calendar, Clock, ArrowRight, MapPin, Phone, Mail } from "lucide-react";
import { articles } from "../components/common/articles";

const BlogDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const currentId = parseInt(id);

  React.useEffect(() => {
    if (!id || !articles[currentId]) {
      navigate("/blog");
    }
  }, [id, currentId, navigate]);

  if (!id || !articles[currentId]) {
    return null;
  }

  const currentContent = articles[currentId];

  console.log("currentContent", currentContent);

  const nextId = currentId < Object.keys(articles).length ? currentId + 1 : 1;
  const relatedContent = articles[nextId];

  const getNextThreeArticles = () => {
    const articleIds = Object.keys(articles);
    const relatedArticles = [];
    let nextId = currentId;

    while (relatedArticles.length < 3) {
      nextId = nextId >= articleIds.length ? 1 : nextId + 1;
      if (nextId !== currentId) {
        relatedArticles.push(articles[nextId]);
      }
    }

    return relatedArticles;
  };

  const handleArticleClick = (articleId) => {
    console.log("articleId", articleId);

    navigate(`/blog/${articleId}`);
    window.scrollTo(0, 0);
  };

  const relatedArticles = getNextThreeArticles();
  console.log("relatedArticles", relatedArticles);

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-8">
            <article className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <header className="relative h-96">
                <img
                  src={currentContent.image}
                  alt={currentContent.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white/60 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <div className="flex items-center gap-4 mb-4 text-sm">
                    <div className="flex items-center">
                      <Calendar className="w-4 h-4 mr-1" />
                      {currentContent.date}
                    </div>
                    <div className="flex items-center">
                      <Clock className="w-4 h-4 mr-1" />
                      {currentContent.readTime}
                    </div>
                  </div>
                  <h1 className="text-4xl font-bold">{currentContent.title}</h1>
                </div>
              </header>

              <div className="p-8 prose prose-lg max-w-none">
                {currentContent.sections.map((section, index) => (
                  <div key={index} className="mb-12">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {section.title}
                    </h2>
                    <div className="text-gray-600 whitespace-pre-line">
                      {section.content}
                    </div>
                    {section.subsections?.map((sub, idx) => (
                      <div key={idx} className="mt-6">
                        <h3 className="text-xl font-semibold text-gray-900 mb-3">
                          {sub.title}
                        </h3>
                        <p className="text-gray-600">{sub.content}</p>
                      </div>
                    ))}
                  </div>
                ))}
              </div>

              <div className="p-8 bg-gradient-to-r from-primary to-secondary">
                <div className="text-center text-white">
                  <h3 className="text-2xl font-bold mb-4">
                    {currentContent?.callToAction?.title}
                  </h3>
                  <p className="mb-8 opacity-90">
                    {currentContent?.callToAction?.description}
                  </p>
                  <div className="flex justify-center gap-4">
                    <Link
                      to={currentContent?.callToAction?.primaryButton?.link}
                      className="bg-white text-primary px-8 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors"
                    >
                      {currentContent?.callToAction?.primaryButton?.text}
                    </Link>
                    <Link
                      to={currentContent?.callToAction?.secondaryButton?.link}
                      className="bg-white/10 text-white px-8 py-3 rounded-lg font-medium hover:bg-white/20 transition-colors"
                    >
                      {currentContent?.callToAction?.secondaryButton.text}
                    </Link>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <div className="lg:col-span-4">
            <div className="sticky top-8 space-y-8">
              <div className="bg-white rounded-xl shadow-sm p-6">
                <h3 className="font-semibold text-gray-900 mb-4">
                  Related Articles
                </h3>
                {relatedArticles.map(
                  (article) =>
                    article && (
                      <div
                        key={article.id}
                        onClick={() => handleArticleClick(article.id)}
                        className="block group cursor-pointer mb-6 last:mb-0"
                      >
                        <div className="flex gap-4">
                          <div className="w-24 h-16 overflow-hidden rounded-lg">
                            <img
                              src={article.image}
                              alt={article.title}
                              className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                            />
                          </div>
                          <div className="flex-1">
                            <h4 className="font-medium text-gray-900 group-hover:text-primary transition-colors line-clamp-2">
                              {article.title}
                            </h4>
                            <span className="inline-flex items-center text-primary mt-2 text-sm">
                              Read article{" "}
                              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                            </span>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>

              <div className="bg-white rounded-xl shadow-sm p-6">
                <h3 className="font-semibold text-gray-900 mb-4">Contact Us</h3>
                <div className="space-y-4">
                  <div className="flex items-center text-gray-600">
                    <Phone className="w-5 h-5 mr-3 text-primary" />
                    <span>Mob : 0452298814 Tel : 0882708801</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <Mail className="w-5 h-5 mr-3 text-primary" />
                    <span>info@enviprosolutions.com.au</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <MapPin className="w-5 h-5 mr-3 text-primary" />
                    <span>Australia</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailPage;
